import { render, staticRenderFns } from "./SonsByIdSpecimen.vue?vue&type=template&id=f2248516&scoped=true"
import script from "./SonsByIdSpecimen.vue?vue&type=script&lang=js"
export * from "./SonsByIdSpecimen.vue?vue&type=script&lang=js"
import style0 from "./SonsByIdSpecimen.vue?vue&type=style&index=0&id=f2248516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2248516",
  null
  
)

export default component.exports